<div [formGroup]="licenseSelectForm">
  <div class="row pb-4">
    <div class="col-12 pb-2">
      <label
        ><input
          name="isDeploy"
          class="licence-select-option-font"
          type="radio"
          formControlName="isDeploy"
          value="false"
          required
        />
        &nbsp; <b> No, I will take care of it later.</b></label
      ><br />
    </div>
    <div class="col-12 pb-2">
      <label
        ><input
          name="isDeploy"
          type="radio"
          class="licence-select-option-font"
          formControlName="isDeploy"
          value="true"
          required
        />
        &nbsp; <b> Yes, deploy now.</b></label
      >
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12">
      <label for="qbVersion">Version</label>
      <rw-single-select
        [id]="'qbVersion'"
        [items]="qbVersSelect"
        [bindLabel]="'label'"
        [bindValue]="'value'"
        [arialabel]="'deploy quickbooks version select'"
        [datapendoid]="'deployquickbooks-version-select'"
        [datatestid]="'deployquickbooks-version-select'"
        [isDisabled]="isDeploy.value === 'false'"
        formControlName="qbVersion"
        (valueChanged)="changeQbVersion()">
      </rw-single-select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12">
      <label for="country">Country</label>
      <rw-single-select
        [id]="'qbCountry'"
        [items]="qbCountriesSelect"
        [bindLabel]="'label'"
        [bindValue]="'value'"
        [arialabel]="'deploy quickbooks country select'"
        [datapendoid]="'deployquickbooks-country-select'"
        [datatestid]="'deployquickbooks-country-select'"
        [isDisabled]="isDeploy.value === 'false'"
        formControlName="qbCountry"
        (valueChanged)="changeQbCountry()">
      </rw-single-select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12">
      <label for="version">Edition</label>
      <rw-single-select
        [id]="'qbEdition'"
        [items]="qbEditionsSelect"
        [bindLabel]="'label'"
        [bindValue]="'value'"
        [arialabel]="'deploy quickbooks edition select'"
        [datapendoid]="'deployquickbooks-edition-select'"
        [datatestid]="'deployquickbooks-edition-select'"
        [isDisabled]="isDeploy.value === 'false'"
        formControlName="qbEdition"
        (valueChanged)="changeQbEdition()">
      </rw-single-select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12">
      <label for="version">Flavor</label>
      <rw-single-select
        [id]="'qbFlavor'"
        [items]="qbFlavorsSelect"
        [bindLabel]="'label'"
        [bindValue]="'value'"
        [arialabel]="'deploy quickbooks flavor select'"
        [datapendoid]="'deployquickbooks-flavor-select'"
        [datatestid]="'deployquickbooks-flavor-select'"
        [isDisabled]="isDeploy.value === 'false'"
        formControlName="qbFlavor"
        (valueChanged)="changeQbFlavor()">
      </rw-single-select>
    </div>
  </div>
</div>
